export default "__VITE_ASSET__C3M0N55a__"